export default {
  ISSUE: 'ISSUE',
  CANCELLATION: 'CANCELLATION',
  EXPIRATION: 'EXPIRATION',
  OUTGOING: 'OUTGOING',
  INCOMING: 'INCOMING',
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT',
  RECALL: 'RECALL',
};
